export function isValidPhone(phone: string): boolean {
  const cleaned = phone.replace(/\D/g, '');
  return cleaned.length >= 10 && cleaned.length <= 13;
}

export function isValidName(name: string): boolean {
  return name.trim().length >= 2;
}

export function isValidCity(city: string): boolean {
  return city.trim().length >= 2;
}

export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function isValidCurrency(value: string): boolean {
  const numValue = parseCurrency(value);
  return !isNaN(numValue) && numValue >= 0;
}

export function parseCurrency(value: string): number {
  const cleaned = value
    .replace(/[R$\s]/g, '')
    .replace(/\./g, '')
    .replace(',', '.');
  return parseFloat(cleaned) || 0;
}
